import BoxInventoryService from 'services/BoxInventoryService'
import CommentsService from 'services/CommentsService'
import CountryService from 'services/CountryService'
import GroupPolicyService from 'services/GroupPolicyService'
import GuaranteeCancelPolicyService from 'services/GuaranteeCancelPolicyService'
import HotelAmenitiesService from 'services/HotelAmenitiesService'
import HotelChargesService from 'services/HotelChargesService'
import HotelCloseoutService from 'services/HotelCloseoutService'
import MultiUserEndpointService from 'services/MultiUserEndpointService'
import OnboardingContactService from 'services/OnboardingContactService'
import OtaRateProgramsService from 'services/OtaRateProgramsService'
import PetPolicyService from 'services/PetPolicyService'
import TermsAndConditionsService from 'services/TermsAndConditionsService'
import DestinationsService from '../services/DestinationsService'
import ExtraChargeService from '../services/ExtraChargeService'
import HotelContactsService from '../services/HotelContactsService'
import HotelInfoService from '../services/HotelInfoService'
import HotelTextService from '../services/HotelTextService'
import MeetingRoomsService from '../services/MeetingRoomsService'
import RateplansService from '../services/RateplansService'
import RoomTypesService from '../services/RoomTypesService'
import RoomTypeBucketsService from "../services/RoomTypeBucketsService";
import HotelContentService from "../services/HotelContentService";
import AgeTiersService from "../services/AgeTiersService";
import SRPInventoryService from "../services/SRPInventoryService";

const GET = 'GET'
const SEARCH = 'SEARCH'
const POST = 'POST'
const PUT = 'PUT'
const DELETE = 'DELETE'

/* ACTIONS */
export const HANDLE_HTTP_RESPONSE = 'HANDLE_HTTP_RESPONSE'
export const HANDLE_HTTP_ERROR_RESPONSE = 'HANDLE_HTTP_ERROR_RESPONSE'
export const HANDLE_USER_LOGIN = 'HANDLE_USER_LOGIN'
export const ASYNC_METHOD = 'ASYNC_METHOD'
export const ASYNC_ACTIONS = {
    GET: GET,
    SEARCH: SEARCH,
    POST: POST,
    PUT: PUT,
    DELETE: DELETE,
    GET_ONBOARDING_STATUS: 'GET_ONBOARDING_STATUS',
    PUT_ONBOARDING_STATUS: 'PUT_ONBOARDING_STATUS',
    PUT_COMMENTS: 'PUT_COMMENTS',
    GET_MASTER_ROOM_AMENITIES: 'GET_MASTER_ROOM_AMENITIES',
    GET_BRAND_SPECIFIC_MASTER_ROOM_AMENITIES: 'GET_BRAND_SPECIFIC_MASTER_ROOM_AMENITIES',
    GET_MASTER_ROOM_TYPE: 'GET_MASTER_ROOM_TYPE',
    ACQUIRE_USER: 'ACQUIRE_USER',
    RESET_USER: 'RESET_USER',
    GET_AIRPORTS: 'GET_AIRPORTS',
    GET_STATES: 'GET_STATES',
    GET_DESTINATION_ACCEPTABLE_VALUES: 'GET_DESTINATION_ACCEPTABLE_VALUES'
}

/* ASYNC METHODS to be passed to asyncMethod from actions */
const ASYNC_METHODS = {
    FORM_ALL: {
        GET_ONBOARDING_STATUS: HotelInfoService.getOnboardingStatus
    },
    FORM_ADMIN_PAGE: {
        ACQUIRE_USER: MultiUserEndpointService.acquireUser,
        RESET_USER: MultiUserEndpointService.resetUser
    },
    FORM_AGE_TIERS: {
        GET: AgeTiersService.getAgeTiers,
        PUT: AgeTiersService.putAgeTiers
    },
    FORM_UPDATE_ONBOARDING: {
        ACQUIRE_USER: MultiUserEndpointService.acquireUser,
        PUT: HotelInfoService.putOnboardingStatus
    },
    FORM_LAUNCH_ONBOARDING_APPLICATION: {
        GET: HotelInfoService.getHotelInfo,
        SEARCH: HotelInfoService.searchOnboardingApplicationsByStatus,
        PUT: HotelInfoService.putHotelInfo
    },
    FORM_HOTEL_CONTACTS: {
        GET: HotelContactsService.getHotelContacts,
        PUT: HotelContactsService.putHotelContacts
    },
    FORM_HOTEL_ONBOARDING_CONTACT: {
        GET: OnboardingContactService.getOnboardingContact,
        PUT: OnboardingContactService.putOnboardingContact
    },
    FORM_HOTEL_INFO: {
        GET: HotelInfoService.getHotelInfo,
        SEARCH: HotelInfoService.searchOnboardingApplicationsByStatus,
        PUT: HotelInfoService.putHotelInfo
    },
    FORM_TERMS_AND_CONDITIONS: {
        GET: HotelInfoService.getHotelInfo,
        SEARCH: HotelInfoService.searchOnboardingApplicationsByStatus,
        PUT: TermsAndConditionsService.putTermsAndConditions,
        POST: HotelInfoService.postHotelInfo
    },
    FORM_SEARCH_HOTEL: {
        GET: HotelInfoService.getHotelInfo,
        SEARCH: HotelInfoService.getOnboardingStatus,
        POST: HotelInfoService.postHotelInfo
    },
    FORM_HOTEL_ONLINE_DISPLAY: {
        GET: HotelTextService.getHotelText,
        PUT: HotelTextService.putHotelText
    },
    FORM_MEETING_ROOMS: {
        GET: MeetingRoomsService.getMeetingRooms,
        PUT: MeetingRoomsService.putMeetingRooms
    },
    FORM_ROOM_TYPES: {
        GET: RoomTypesService.getRoomTypes,
        GET_MASTER_ROOM_AMENITIES: RoomTypesService.getMasterRoomAmenities,
        GET_BRAND_SPECIFIC_MASTER_ROOM_AMENITIES: RoomTypesService.getBrandSpecificMasterRoomAmenities,
        GET_MASTER_ROOM_TYPE: RoomTypesService.getMasterRoomType,
        PUT: RoomTypesService.putRoomTypes
    },
    FORM_ROOM_TYPE_BUCKETS: {
        GET: RoomTypeBucketsService.getRoomTypesBuckets,
        POST: RoomTypeBucketsService.postRoomTypesBuckets,
        PUT: RoomTypeBucketsService.putRoomTypesBuckets
    },
    FORM_HOTEL_CONTENT_NAME: {
        GET: HotelContentService.getHotelContents,
        PUT: HotelContentService.putHotelContent,
        POST: HotelContentService.postHotelContent,
        DELETE: HotelContentService.deleteHotelContent
    },
    FORM_EXTRA_CHARGES: {
        GET: ExtraChargeService.getExtraCharges,
        PUT: ExtraChargeService.putExtraCharge
    },
    FORM_DESTINATIONS: {
        GET: DestinationsService.getHotelDestinations,
        PUT: DestinationsService.putHotelDestinations,
        GET_AIRPORTS: DestinationsService.getIataLocations,
        GET_STATES: CountryService.getCountries,
        GET_DESTINATION_ACCEPTABLE_VALUES: DestinationsService.getAcceptableValues
    },
    FORM_PET_POLICY: {
        GET: PetPolicyService.getPetPolicy,
        PUT: PetPolicyService.putPetPolicy
    },
    FORM_GROUP_POLICY: {
        GET: GroupPolicyService.getGroupPolicy,
        PUT: GroupPolicyService.putGroupPolicy
    },
    FORM_GUARANTEE_CANCEL_POLICY: {
        GET: GuaranteeCancelPolicyService.getGuaranteeCancelPolicy,
        PUT: GuaranteeCancelPolicyService.putGuaranteeCancelPolicy
    },
    FORM_BOX_INVENTORY: {
        PUT: BoxInventoryService.putBoxInventory
    },
    FORM_SRP_INVENTORY: {
        GET: SRPInventoryService.getSrpInventory,
        PUT: SRPInventoryService.putSrpInventory
    },
    FORM_OTA_RATE_PROGRAMS: {
        GET: OtaRateProgramsService.getOtaRatePrograms,
        PUT: OtaRateProgramsService.putOtaRatePrograms
    },
    FORM_OTHER_RATEPLANS: {
        GET: RateplansService.getRateplans,
        PUT: RateplansService.putRateplans
    },
    FORM_RATEPLAN_BLACKOUTS: {
        GET: RateplansService.getBlackouts,
        PUT: RateplansService.putBlackouts
    },
    FORM_FEEDBACK: {
        PUT_ONBOARDING_STATUS: HotelInfoService.putOnboardingStatus,
        PUT_COMMENTS: CommentsService.putComments
    },
    FORM_HOTEL_CHARGES: {
        PUT: HotelChargesService.putHotelTaxes
    },
    FORM_HOTEL_AMENITIES_NAME: {
        PUT: HotelAmenitiesService.putHotelAmenities
    },
    FORM_INVENTORY_CLOSEOUTS: {
        PUT: HotelCloseoutService.putHotelCloseouts
    },
    FORM_RACK_RATES: {
        PUT: RateplansService.putBaseRateplans
    }
}

/* Retrieves the async method to be executed based on the form name and the action */
export const retrieveAsnycMethod = (formName, action) => {
    const formDetails = ASYNC_METHODS[formName]
    if (formDetails) {
        const actionDetails = ASYNC_ACTIONS[action]
        if (actionDetails) {
            return formDetails[action]
        }
    }
    return null
}
